export default "/assets/0fd8e1863fd315cb.png"